// ════════════════════════════════════════════════════
// MENSCHEN A2.1 — Interactive Exercises
// 12 Lessons (L1-L12) × 3 types × 3 difficulties = 108 exercises
// A2-level grammar: Präteritum, Konjunktiv II, Nebensätze, Wechselpräpositionen
// ════════════════════════════════════════════════════

const EXERCISES_A21 = {
  // ──────── LEKTION 1: Mein Opa war auch schon Bäcker ────────
  L1: {
    title: 'Lektion 1: Mein Opa war auch schon Bäcker.',
    worter: {
      leicht: { type: 'sort', instruction: 'Berufe: Früher oder Heute?',
        categories: ['Traditionelle Berufe', 'Moderne Berufe'],
        items: [
          { word: 'der Bäcker', cat: 0 }, { word: 'der Schneider', cat: 0 },
          { word: 'der Schuster', cat: 0 }, { word: 'der Schmied', cat: 0 },
          { word: 'der Informatiker', cat: 1 }, { word: 'der Webdesigner', cat: 1 },
          { word: 'der Programmierer', cat: 1 }, { word: 'die Managerin', cat: 1 },
          { word: 'der Tischler', cat: 0 }, { word: 'die Influencerin', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Familiengeschichte: Ergänzen Sie.',
        sentences: [
          { text: 'Mein Großvater ___ Bäcker. (was)', options: ['war', 'ist', 'hat'], answer: 0 },
          { text: 'Er ___ jeden Morgen um 3 Uhr auf. (got up)', options: ['stand', 'steht', 'stehte'], answer: 0 },
          { text: 'Meine Großmutter ___ im Geschäft. (worked)', options: ['arbeitete', 'arbeitet', 'arbeit'], answer: 0 },
          { text: 'Sie ___ auch Kuchen und Torten. (baked)', options: ['backt', 'backte', 'buk'], answer: 1 },
          { text: 'Mein Vater ___ den Beruf nicht weiter. (continued)', options: ['machte', 'führte', 'lernte'], answer: 1 },
          { text: 'Er ___ Ingenieur. (became)', options: ['wurde', 'war', 'ist'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Über die Vergangenheit sprechen.',
        sentences: [
          { text: 'Als Kind ___ ich immer bei meinen Großeltern. (was)', options: ['bin', 'war', 'hatte'], answer: 1 },
          { text: 'Früher ___ es kein Internet. (there was)', options: ['gab', 'gibt', 'war'], answer: 0 },
          { text: 'Meine Eltern ___ kein Auto. (had)', options: ['haben', 'hatten', 'waren'], answer: 1 },
          { text: 'In der Schule ___ wir viel Sport. (did)', options: ['machten', 'machen', 'gemacht'], answer: 0 },
          { text: 'Am Wochenende ___ die ganze Familie zusammen. (came)', options: ['kam', 'kommt', 'gekommen'], answer: 0 },
          { text: 'Mein Großvater ___ viele Geschichten. (erzählen)', options: ['erzählte', 'erzählt', 'erzählen'], answer: 0 },
          { text: 'Wir ___ jeden Sommer ans Meer. (fahren)', options: ['fuhren', 'fahren', 'gefahren'], answer: 0 },
          { text: 'Meine Mutter ___ fantastisch. (kochen)', options: ['kochte', 'kocht', 'gekocht'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Präteritum von „sein" und „haben".',
        sentences: [
          { text: 'Ich ___ gestern müde. (sein)', options: ['war', 'bin', 'hatte'], answer: 0 },
          { text: 'Er ___ keine Zeit. (haben)', options: ['war', 'hatte', 'hat'], answer: 1 },
          { text: 'Wir ___ im Urlaub. (sein)', options: ['waren', 'hatten', 'sind'], answer: 0 },
          { text: 'Sie ___ zwei Kinder. (haben)', options: ['waren', 'hatten', 'sind'], answer: 1 },
          { text: 'Du ___ krank. (sein)', options: ['hattest', 'warst', 'bist'], answer: 1 },
          { text: '___ ihr auch dort? (sein)', options: ['Wart', 'Hattet', 'Seid'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: 'Präteritum: Regelmäßige Verben.',
        sentences: [
          { text: 'Er ___ in Berlin. (wohnen)', options: ['wohnte', 'wohnt', 'gewohnt'], answer: 0 },
          { text: 'Sie ___ als Lehrerin. (arbeiten)', options: ['arbeitete', 'arbeitet', 'gearbeitet'], answer: 0 },
          { text: 'Wir ___ viel Deutsch. (lernen)', options: ['lernten', 'lernen', 'gelernt'], answer: 0 },
          { text: 'Ich ___ Tennis. (spielen)', options: ['spielte', 'spielt', 'gespielt'], answer: 0 },
          { text: 'Die Kinder ___ im Garten. (spielen)', options: ['spielten', 'spielen', 'gespielt'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Sätze im Präteritum ordnen.',
        sentences: [
          { words: ['war', 'Mein', 'Opa', 'Bäcker'], answer: 'Mein Opa war Bäcker' },
          { words: ['hatten', 'Wir', 'einen', 'Hund'], answer: 'Wir hatten einen Hund' },
          { words: ['wohnte', 'Sie', 'in', 'Hamburg'], answer: 'Sie wohnte in Hamburg' },
          { words: ['es', 'gab', 'Früher', 'kein', 'Fernsehen'], answer: 'Früher gab es kein Fernsehen' },
          { words: ['arbeitete', 'Mein', 'Vater', 'viel'], answer: 'Mein Vater arbeitete viel' },
          { words: ['waren', 'Die', 'Kinder', 'sehr', 'glücklich'], answer: 'Die Kinder waren sehr glücklich' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Über die Vergangenheit sprechen.',
        pairs: [
          { q: 'Was war dein Opa von Beruf?', a: 'Er war Bäcker.' },
          { q: 'Wo hast du als Kind gewohnt?', a: 'In einem kleinen Dorf.' },
          { q: 'Hattest du Geschwister?', a: 'Ja, einen Bruder und eine Schwester.' },
          { q: 'Wie war deine Kindheit?', a: 'Sehr schön. Wir spielten viel draußen.' },
        ]},
      mittel: { type: 'gap', instruction: 'Familiengeschichte erzählen.',
        sentences: [
          { text: 'A: Was ___ dein Großvater von Beruf?', options: ['war', 'ist', 'hat'], answer: 0 },
          { text: 'B: Er ___ Tischler. Er ___ sehr gute Möbel.', options: ['war...machte', 'ist...macht', 'hat...macht'], answer: 0 },
          { text: 'A: Und deine Großmutter?', options: ['Was machte sie?', 'Was macht sie?', 'Was hat sie?'], answer: 0 },
          { text: 'B: Sie ___ zu Hause und ___ für die Familie.', options: ['blieb...sorgte', 'bleibt...sorgt', 'war...hat'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Generationen vergleichen.',
        sentences: [
          { text: 'Früher ___ man mit der Hand. Heute benutzt man Maschinen.', options: ['arbeitete', 'arbeitet', 'gearbeitet'], answer: 0 },
          { text: 'Mein Opa ___ kein Handy. Er ___ Briefe.', options: ['hatte...schrieb', 'hat...schreibt', 'war...schreibt'], answer: 0 },
          { text: 'Heute ___ vieles anders als früher.', options: ['ist', 'war', 'hat'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 2: Wohin mit der Kommode? ────────
  L2: {
    title: 'Lektion 2: Wohin mit der Kommode?',
    worter: {
      leicht: { type: 'sort', instruction: 'Möbel: Wohnzimmer oder Schlafzimmer?',
        categories: ['Wohnzimmer', 'Schlafzimmer'],
        items: [
          { word: 'das Sofa', cat: 0 }, { word: 'der Couchtisch', cat: 0 },
          { word: 'das Regal', cat: 0 }, { word: 'der Fernseher', cat: 0 },
          { word: 'das Bett', cat: 1 }, { word: 'der Kleiderschrank', cat: 1 },
          { word: 'die Kommode', cat: 1 }, { word: 'der Nachttisch', cat: 1 },
          { word: 'die Stehlampe', cat: 0 }, { word: 'die Matratze', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Umzug: Wohin stellen wir die Möbel?',
        sentences: [
          { text: 'Stell die Kommode ___ die Wand!', options: ['an', 'auf', 'in'], answer: 0 },
          { text: 'Leg den Teppich ___ den Boden!', options: ['an', 'auf', 'in'], answer: 1 },
          { text: 'Häng das Bild ___ die Wand!', options: ['auf', 'an', 'in'], answer: 1 },
          { text: 'Stell die Bücher ___ das Regal!', options: ['auf', 'an', 'in'], answer: 2 },
          { text: 'Stell den Tisch ___ das Fenster!', options: ['vor', 'auf', 'in'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Wechselpräpositionen: Wohin? → Akkusativ.',
        sentences: [
          { text: 'Ich stelle die Lampe ___ den Tisch. (auf)', options: ['auf', 'am', 'im'], answer: 0 },
          { text: 'Er legt das Buch ___ die Tasche. (in)', options: ['in', 'im', 'ins'], answer: 0 },
          { text: 'Sie hängt das Foto ___ die Wand. (an)', options: ['an', 'am', 'auf'], answer: 0 },
          { text: 'Wir stellen das Sofa ___ das Fenster. (neben)', options: ['neben', 'neben dem', 'neben der'], answer: 0 },
          { text: 'Leg den Teppich ___ den Boden! (auf)', options: ['auf', 'an', 'in'], answer: 0 },
          { text: 'Stell den Stuhl ___ den Tisch! (vor)', options: ['vor', 'für', 'in'], answer: 0 },
          { text: 'Häng die Uhr ___ die Wand! (an)', options: ['an', 'in', 'auf'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Wechselpräpositionen: Wo? (Dativ) oder Wohin? (Akkusativ)',
        sentences: [
          { text: 'Das Buch liegt ___ dem Tisch. (Wo?)', options: ['auf', 'an', 'in'], answer: 0 },
          { text: 'Ich lege das Buch ___ den Tisch. (Wohin?)', options: ['auf', 'an', 'in'], answer: 0 },
          { text: 'Die Lampe steht ___ der Kommode. (Wo?)', options: ['auf', 'an', 'in'], answer: 0 },
          { text: 'Stell die Lampe ___ die Kommode! (Wohin?)', options: ['auf', 'an', 'in'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: 'stellen/stehen, legen/liegen, hängen.',
        sentences: [
          { text: 'Die Vase ___ auf dem Regal. (steht/stellt)', options: ['steht', 'stellt', 'liegt'], answer: 0 },
          { text: 'Ich ___ die Vase auf das Regal. (stelle/stehe)', options: ['stelle', 'stehe', 'lege'], answer: 0 },
          { text: 'Das Bild ___ an der Wand. (hängt)', options: ['hängt', 'liegt', 'steht'], answer: 0 },
          { text: 'Die Katze ___ auf dem Sofa. (liegt/legt)', options: ['liegt', 'legt', 'steht'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Anweisungen beim Umzug ordnen.',
        sentences: [
          { words: ['die', 'Stell', 'Kommode', 'an', 'die', 'Wand'], answer: 'Stell die Kommode an die Wand' },
          { words: ['den', 'Leg', 'Teppich', 'auf', 'den', 'Boden'], answer: 'Leg den Teppich auf den Boden' },
          { words: ['das', 'Häng', 'Bild', 'über', 'das', 'Sofa'], answer: 'Häng das Bild über das Sofa' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Beim Umzug helfen.',
        pairs: [
          { q: 'Wohin soll die Kommode?', a: 'Stell sie an die Wand.' },
          { q: 'Wo ist der Teppich?', a: 'Er liegt im Wohnzimmer.' },
          { q: 'Soll ich das Bild aufhängen?', a: 'Ja, bitte über das Sofa.' },
          { q: 'Wohin kommt der Schreibtisch?', a: 'Stell ihn vor das Fenster.' },
        ]},
      mittel: { type: 'gap', instruction: 'Umzugsgespräch.',
        sentences: [
          { text: 'A: ___ soll ich den Schrank stellen?', options: ['Wohin', 'Wo', 'Was'], answer: 0 },
          { text: 'B: ___ ihn ins Schlafzimmer.', options: ['Stell', 'Steht', 'Liegt'], answer: 0 },
          { text: 'A: Und ___ kommt das Regal?', options: ['wohin', 'wo', 'was'], answer: 0 },
          { text: 'B: ___ Wohnzimmer, ___ die Wand.', options: ['Ins...an', 'Im...an', 'Ins...auf'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Neue Wohnung beschreiben.',
        sentences: [
          { text: 'In meinem Zimmer ___ ein großes Fenster.', options: ['gibt es', 'steht', 'liegt'], answer: 0 },
          { text: 'Das Bett steht ___ der Wand.', options: ['an', 'auf', 'in'], answer: 0 },
          { text: 'Über dem Bett ___ ein Poster.', options: ['hängt', 'steht', 'liegt'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 3: Ich würde am liebsten jeden Tag feiern ────────
  L3: {
    title: 'Lektion 3: Ich würde am liebsten jeden Tag feiern.',
    worter: {
      leicht: { type: 'sort', instruction: 'Feste und Feiern: Was braucht man?',
        categories: ['Essen & Trinken', 'Dekoration & Sonstiges'],
        items: [
          { word: 'der Kuchen', cat: 0 }, { word: 'die Getränke', cat: 0 },
          { word: 'die Torte', cat: 0 }, { word: 'der Sekt', cat: 0 },
          { word: 'die Luftballons', cat: 1 }, { word: 'die Girlande', cat: 1 },
          { word: 'die Kerzen', cat: 1 }, { word: 'das Geschenk', cat: 1 },
          { word: 'die Einladung', cat: 1 }, { word: 'die Musik', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Konjunktiv II: Wünsche ausdrücken.',
        sentences: [
          { text: 'Ich ___ gern eine Party machen. (would)', options: ['würde', 'werde', 'will'], answer: 0 },
          { text: 'Er ___ am liebsten den ganzen Tag feiern.', options: ['würde', 'will', 'soll'], answer: 0 },
          { text: 'Wir ___ gern mehr Freunde einladen.', options: ['würden', 'werden', 'wollen'], answer: 0 },
          { text: '___ du mir bei der Vorbereitung helfen?', options: ['Würdest', 'Wirst', 'Willst'], answer: 0 },
          { text: 'Ich ___ am liebsten am Strand feiern.', options: ['würde', 'werde', 'will'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Feste planen.',
        sentences: [
          { text: 'Für die Party ___ wir noch Getränke besorgen.', options: ['müssen', 'würden', 'können'], answer: 0 },
          { text: 'Die ___ sind schon verschickt.', options: ['Einladungen', 'Geschenke', 'Kuchen'], answer: 0 },
          { text: 'Wir haben eine ___ mit 5 Stockwerken bestellt!', options: ['Girlande', 'Torte', 'Kerze'], answer: 1 },
          { text: 'Die ___ beginnt um 20 Uhr.', options: ['Feier', 'Arbeit', 'Schule'], answer: 0 },
          { text: 'Ich ___ dir gern bei der Vorbereitung helfen.', options: ['würde', 'werde', 'will'], answer: 0 },
          { text: 'Am liebsten ___ ich am Strand feiern.', options: ['würde', 'werde', 'war'], answer: 0 },
          { text: 'Die ___ ist am Samstag um 20 Uhr.', options: ['Feier', 'Pause', 'Arbeit'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Konjunktiv II mit „würde".',
        sentences: [
          { text: 'Ich ___ gern verreisen.', options: ['würde', 'werde', 'war'], answer: 0 },
          { text: 'Du ___ gern Klavier spielen.', options: ['würdest', 'wirst', 'warst'], answer: 0 },
          { text: 'Er/Sie ___ gern mehr Sport machen.', options: ['würde', 'wird', 'war'], answer: 0 },
          { text: 'Wir ___ gern in den Urlaub fahren.', options: ['würden', 'werden', 'waren'], answer: 0 },
          { text: '___ ihr gern tanzen gehen?', options: ['Würdet', 'Werdet', 'Wart'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: 'Konjunktiv II: Höfliche Bitten.',
        sentences: [
          { text: '___ Sie mir bitte helfen?', options: ['Könnten', 'Können', 'Konnten'], answer: 0 },
          { text: 'Ich ___ gern ein Stück Kuchen.', options: ['hätte', 'habe', 'hatte'], answer: 0 },
          { text: '___ Sie so freundlich sein?', options: ['Wären', 'Sind', 'Waren'], answer: 0 },
          { text: 'Ich ___ Sie gern etwas fragen.', options: ['würde', 'werde', 'will'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Wunschsätze ordnen.',
        sentences: [
          { words: ['würde', 'Ich', 'gern', 'eine', 'Party', 'machen'], answer: 'Ich würde gern eine Party machen' },
          { words: ['könnten', 'Wir', 'zusammen', 'kochen'], answer: 'Wir könnten zusammen kochen' },
          { words: ['würdest', 'Du', 'gern', 'tanzen', 'gehen', '?'], answer: 'Würdest du gern tanzen gehen?' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Party planen.',
        pairs: [
          { q: 'Was würdest du gern machen?', a: 'Ich würde gern eine Party machen.' },
          { q: 'Könntest du die Getränke besorgen?', a: 'Ja, klar. Kein Problem.' },
          { q: 'Wann soll die Party sein?', a: 'Am Samstag um 20 Uhr.' },
          { q: 'Hättest du gern Kuchen oder Torte?', a: 'Lieber eine Schokoladentorte.' },
        ]},
      mittel: { type: 'gap', instruction: 'Einladung schreiben.',
        sentences: [
          { text: 'Liebe Freunde, ich ___ euch herzlich zu meiner Party ein.', options: ['lade', 'würde', 'hätte'], answer: 0 },
          { text: 'Die Feier ___ am Samstag, den 15. März statt.', options: ['findet', 'hat', 'wird'], answer: 0 },
          { text: 'Ich ___ mich sehr über euer Kommen freuen.', options: ['würde', 'werde', 'hatte'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Auf eine Einladung reagieren.',
        sentences: [
          { text: 'Danke für die ___! Ich komme gern.', options: ['Einladung', 'Geschenk', 'Torte'], answer: 0 },
          { text: 'Leider ___ ich nicht kommen. Ich habe schon einen Termin.', options: ['kann', 'würde', 'muss'], answer: 0 },
          { text: '___ ich etwas mitbringen?', options: ['Soll', 'Würde', 'Hätte'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 4: Ich bin so aufgeregt! ────────
  L4: {
    title: 'Lektion 4: Ich bin so aufgeregt!',
    worter: {
      leicht: { type: 'sort', instruction: 'Gefühle: Positiv oder Negativ?',
        categories: ['Positiv / Positive', 'Negativ / Negative'],
        items: [
          { word: 'aufgeregt (excited)', cat: 0 }, { word: 'glücklich (happy)', cat: 0 },
          { word: 'stolz (proud)', cat: 0 }, { word: 'zufrieden (satisfied)', cat: 0 },
          { word: 'traurig (sad)', cat: 1 }, { word: 'ärgerlich (angry)', cat: 1 },
          { word: 'enttäuscht (disappointed)', cat: 1 }, { word: 'nervös (nervous)', cat: 1 },
          { word: 'begeistert (enthusiastic)', cat: 0 }, { word: 'einsam (lonely)', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Gefühle ausdrücken mit Adjektiven.',
        sentences: [
          { text: 'Ich bin so ___! Morgen fliege ich nach Deutschland.', options: ['aufgeregt', 'traurig', 'müde'], answer: 0 },
          { text: 'Er ist ___, weil er die Prüfung bestanden hat.', options: ['traurig', 'stolz', 'ärgerlich'], answer: 1 },
          { text: 'Sie ist ___, weil ihr Hund weggelaufen ist.', options: ['glücklich', 'zufrieden', 'traurig'], answer: 2 },
          { text: 'Wir sind ___ über das Ergebnis.', options: ['enttäuscht', 'stolz', 'aufgeregt'], answer: 0 },
          { text: 'Ich fühle mich heute sehr ___.', options: ['glücklich', 'nervös', 'beides geht'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Reflexivverben mit Gefühlen.',
        sentences: [
          { text: 'Ich ___ mich auf die Reise. (freuen)', options: ['freue', 'ärgere', 'fühle'], answer: 0 },
          { text: 'Er ___ sich über die Nachricht. (ärgern)', options: ['ärgert', 'freut', 'fühlt'], answer: 0 },
          { text: 'Wir ___ uns auf das Wiedersehen. (freuen)', options: ['freuen', 'ärgern', 'fühlen'], answer: 0 },
          { text: 'Sie ___ sich sehr allein. (fühlen)', options: ['fühlt', 'freut', 'ärgert'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Reflexivpronomen: mich, dich, sich, uns, euch.',
        sentences: [
          { text: 'Ich freue ___ auf dich.', options: ['mich', 'dich', 'sich'], answer: 0 },
          { text: 'Er ärgert ___ über den Regen.', options: ['mich', 'sich', 'dich'], answer: 1 },
          { text: 'Wir fühlen ___ wohl hier.', options: ['uns', 'euch', 'sich'], answer: 0 },
          { text: 'Freust du ___?', options: ['mich', 'dich', 'sich'], answer: 1 },
          { text: 'Die Kinder freuen ___ auf Weihnachten.', options: ['uns', 'euch', 'sich'], answer: 2 },
        ]},
      mittel: { type: 'gap', instruction: 'Nebensätze mit „weil": Gründe angeben.',
        sentences: [
          { text: 'Ich bin glücklich, ___ ich eine neue Wohnung habe.', options: ['weil', 'dass', 'wenn'], answer: 0 },
          { text: 'Er ist nervös, ___ er morgen eine Prüfung hat.', options: ['weil', 'dass', 'obwohl'], answer: 0 },
          { text: 'Sie weint, ___ sie traurig ist.', options: ['weil', 'dass', 'wenn'], answer: 0 },
          { text: 'Wir sind müde, ___ wir lange gearbeitet haben.', options: ['weil', 'dass', 'obwohl'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Sätze mit „weil" ordnen. (Verb am Ende!)',
        sentences: [
          { words: ['bin', 'Ich', 'froh', 'weil', 'ich', 'dich', 'sehe'], answer: 'Ich bin froh weil ich dich sehe' },
          { words: ['ist', 'Er', 'traurig', 'weil', 'sie', 'weggegangen', 'ist'], answer: 'Er ist traurig weil sie weggegangen ist' },
          { words: ['freue', 'Ich', 'mich', 'weil', 'bald', 'Urlaub', 'ist'], answer: 'Ich freue mich weil bald Urlaub ist' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Nach Gefühlen fragen und reagieren.',
        pairs: [
          { q: 'Wie fühlst du dich?', a: 'Ich bin aufgeregt und nervös.' },
          { q: 'Warum bist du traurig?', a: 'Weil mein Freund weggezogen ist.' },
          { q: 'Freust du dich auf die Party?', a: 'Ja, sehr! Ich bin total aufgeregt.' },
          { q: 'Was ist los?', a: 'Nichts, ich bin nur ein bisschen müde.' },
        ]},
      mittel: { type: 'gap', instruction: 'Über Gefühle sprechen.',
        sentences: [
          { text: 'A: Du siehst aber ___ aus! Was ist passiert?', options: ['glücklich', 'traurig', 'müde'], answer: 0 },
          { text: 'B: Ich habe die ___! Ich bin so stolz!', options: ['Prüfung bestanden', 'Arbeit verloren', 'Party verpasst'], answer: 0 },
          { text: 'A: Das ist ja ___! Herzlichen Glückwunsch!', options: ['toll', 'schade', 'schlimm'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Trösten und Mut machen.',
        sentences: [
          { text: 'Das wird schon ___. Kopf hoch!', options: ['wieder', 'nie', 'immer'], answer: 0 },
          { text: 'Ich kann verstehen, dass du ___ bist.', options: ['enttäuscht', 'glücklich', 'zufrieden'], answer: 0 },
          { text: 'Mach dir keine ___! Es wird besser.', options: ['Sorgen', 'Freude', 'Angst'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 5: Ich brauche kein Büro ────────
  L5: {
    title: 'Lektion 5: Ich brauche kein Büro.',
    worter: {
      leicht: { type: 'sort', instruction: 'Arbeit: Im Büro oder im Homeoffice?',
        categories: ['Im Büro', 'Im Homeoffice'],
        items: [
          { word: 'der Schreibtisch', cat: 0 }, { word: 'der Drucker', cat: 0 },
          { word: 'die Besprechung', cat: 0 }, { word: 'die Kantine', cat: 0 },
          { word: 'der Laptop', cat: 1 }, { word: 'die Videokonferenz', cat: 1 },
          { word: 'das Sofa', cat: 1 }, { word: 'der Schlafanzug', cat: 1 },
          { word: 'die Kaffeemaschine', cat: 0 }, { word: 'die flexible Arbeitszeit', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Arbeitswelt: Ergänzen Sie.',
        sentences: [
          { text: 'Im Homeoffice kann man ___ arbeiten. (flexible)', options: ['flexibel', 'schnell', 'laut'], answer: 0 },
          { text: 'Für eine Videokonferenz braucht man eine gute ___-Verbindung.', options: ['Telefon', 'Internet', 'Radio'], answer: 1 },
          { text: 'Im Büro gibt es eine ___ für das Mittagessen.', options: ['Küche', 'Kantine', 'Bar'], answer: 1 },
          { text: 'Der ___ druckt die Dokumente aus.', options: ['Computer', 'Drucker', 'Scanner'], answer: 1 },
        ]},
      schwer: { type: 'gap', instruction: 'Vor- und Nachteile von Homeoffice.',
        sentences: [
          { text: 'Ein Vorteil ist: Man spart ___ für den Weg zur Arbeit.', options: ['Geld', 'Zeit', 'Platz'], answer: 1 },
          { text: 'Ein Nachteil: Man hat weniger ___ mit Kollegen.', options: ['Kontakt', 'Arbeit', 'Stress'], answer: 0 },
          { text: 'Im Homeoffice fällt es manchmal schwer, Arbeit und ___ zu trennen.', options: ['Freizeit', 'Essen', 'Sport'], answer: 0 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Nebensätze mit „dass".',
        sentences: [
          { text: 'Ich finde, ___ Homeoffice praktisch ist.', options: ['dass', 'weil', 'wenn'], answer: 0 },
          { text: 'Er sagt, ___ er lieber im Büro arbeitet.', options: ['dass', 'weil', 'wenn'], answer: 0 },
          { text: 'Sie meint, ___ Videokonferenzen anstrengend sind.', options: ['dass', 'weil', 'wenn'], answer: 0 },
          { text: 'Wir glauben, ___ flexible Arbeitszeit gut ist.', options: ['dass', 'weil', 'wenn'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: '„dass" vs. „weil" — Unterschied.',
        sentences: [
          { text: 'Ich denke, ___ er recht hat. (opinion)', options: ['dass', 'weil', 'wenn'], answer: 0 },
          { text: 'Ich bleibe zu Hause, ___ ich krank bin. (reason)', options: ['dass', 'weil', 'wenn'], answer: 1 },
          { text: 'Sie sagt, ___ der Termin verschoben wurde.', options: ['dass', 'weil', 'wenn'], answer: 0 },
          { text: 'Er kommt nicht, ___ er arbeiten muss.', options: ['dass', 'weil', 'wenn'], answer: 1 },
        ]},
      schwer: { type: 'order', instruction: 'Nebensätze mit „dass" ordnen.',
        sentences: [
          { words: ['glaube', 'Ich', 'dass', 'Homeoffice', 'gut', 'ist'], answer: 'Ich glaube dass Homeoffice gut ist' },
          { words: ['findet', 'Er', 'dass', 'die', 'Arbeit', 'stressig', 'ist'], answer: 'Er findet dass die Arbeit stressig ist' },
          { words: ['sagt', 'Sie', 'dass', 'sie', 'morgen', 'kommt'], answer: 'Sie sagt dass sie morgen kommt' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Über Arbeit sprechen.',
        pairs: [
          { q: 'Arbeitest du im Büro oder zu Hause?', a: 'Meistens zu Hause, im Homeoffice.' },
          { q: 'Was findest du besser?', a: 'Ich finde Homeoffice praktischer.' },
          { q: 'Vermisst du die Kollegen?', a: 'Ja, manchmal. Den Kontakt vermisse ich.' },
          { q: 'Brauchst du ein Büro?', a: 'Nein, ich brauche nur meinen Laptop.' },
        ]},
      mittel: { type: 'gap', instruction: 'Meinungen austauschen.',
        sentences: [
          { text: 'A: Ich finde, ___ man im Homeoffice produktiver ist.', options: ['dass', 'weil', 'ob'], answer: 0 },
          { text: 'B: Das stimmt ___ immer. Manchmal ist es auch schwierig.', options: ['nicht', 'sehr', 'total'], answer: 0 },
          { text: 'A: Ja, ___ hast du recht.', options: ['da', 'dort', 'hier'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Jobinterview: Fragen und Antworten.',
        sentences: [
          { text: 'Was sind Ihre ___?', options: ['Stärken', 'Hobbys', 'Freunde'], answer: 0 },
          { text: 'Ich bin ___ und kann gut im Team arbeiten.', options: ['zuverlässig', 'müde', 'nervös'], answer: 0 },
          { text: 'Wann ___ Sie anfangen?', options: ['könnten', 'mussten', 'wollten'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 6: Ganz schön mobil ────────
  L6: {
    title: 'Lektion 6: Ganz schön mobil.',
    worter: {
      leicht: { type: 'sort', instruction: 'Verkehrsmittel: Öffentlich oder Privat?',
        categories: ['Öffentlich / Public', 'Privat / Private'],
        items: [
          { word: 'der Bus', cat: 0 }, { word: 'die Straßenbahn', cat: 0 },
          { word: 'die U-Bahn', cat: 0 }, { word: 'der Zug', cat: 0 },
          { word: 'das Auto', cat: 1 }, { word: 'das Fahrrad', cat: 1 },
          { word: 'der Roller', cat: 1 }, { word: 'das Motorrad', cat: 1 },
          { word: 'die S-Bahn', cat: 0 }, { word: 'der E-Scooter', cat: 1 },
        ]},
      mittel: { type: 'gap', instruction: 'Mobilität in der Stadt.',
        sentences: [
          { text: 'Ich fahre jeden Tag mit der ___ zur Arbeit.', options: ['U-Bahn', 'Fuß', 'Hand'], answer: 0 },
          { text: 'Ein ___ ist billiger als ein Auto.', options: ['Fahrrad', 'Motorrad', 'Roller'], answer: 0 },
          { text: 'Der Zug hat 10 Minuten ___.', options: ['Verspätung', 'Pause', 'Abfahrt'], answer: 0 },
          { text: 'Bitte ___ Sie an der nächsten Haltestelle aus!', options: ['steigen', 'fahren', 'gehen'], answer: 0 },
          { text: 'Ich habe eine Monatskarte für den ___.', options: ['Nahverkehr', 'Fernverkehr', 'Flugverkehr'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Vergleiche: Verkehrsmittel.',
        sentences: [
          { text: 'Das Fahrrad ist ___ als das Auto. (environmentally friendlier)', options: ['schneller', 'umweltfreundlicher', 'teurer'], answer: 1 },
          { text: 'Der Zug ist ___ als das Flugzeug. (slower)', options: ['langsamer', 'schneller', 'teurer'], answer: 0 },
          { text: 'Ein E-Auto ist ___ als ein Dieselauto. (quieter)', options: ['lauter', 'leiser', 'schneller'], answer: 1 },
        ]},
    },
    strukturen: {
      leicht: { type: 'gap', instruction: 'Komparativ: Vergleiche bilden.',
        sentences: [
          { text: 'Der Bus ist ___ als die U-Bahn. (langsam)', options: ['langsamer', 'langsam', 'am langsamsten'], answer: 0 },
          { text: 'Das Flugzeug ist ___ als der Zug. (schnell)', options: ['schneller', 'schnell', 'am schnellsten'], answer: 0 },
          { text: 'Ein Fahrrad ist ___ als ein Auto. (billig)', options: ['billiger', 'billig', 'am billigsten'], answer: 0 },
          { text: 'Köln ist ___ als München. (klein)', options: ['kleiner', 'klein', 'am kleinsten'], answer: 0 },
        ]},
      mittel: { type: 'gap', instruction: 'Superlativ: am ...sten.',
        sentences: [
          { text: 'Das Flugzeug ist ___ schnellsten.', options: ['am', 'das', 'der'], answer: 0 },
          { text: 'Das Fahrrad ist ___ billigsten.', options: ['am', 'das', 'der'], answer: 0 },
          { text: 'Berlin ist die ___ Stadt Deutschlands. (biggest)', options: ['größte', 'kleinste', 'schönste'], answer: 0 },
          { text: 'Der ICE ist der ___ Zug. (fastest)', options: ['schnellste', 'langsamste', 'billigste'], answer: 0 },
        ]},
      schwer: { type: 'order', instruction: 'Vergleichssätze ordnen.',
        sentences: [
          { words: ['ist', 'Der', 'Zug', 'schneller', 'als', 'der', 'Bus'], answer: 'Der Zug ist schneller als der Bus' },
          { words: ['am', 'Das', 'Flugzeug', 'ist', 'schnellsten'], answer: 'Das Flugzeug ist am schnellsten' },
          { words: ['lieber', 'Ich', 'fahre', 'mit', 'dem', 'Fahrrad'], answer: 'Ich fahre lieber mit dem Fahrrad' },
        ]},
    },
    kommunikation: {
      leicht: { type: 'match', instruction: 'Über Verkehrsmittel sprechen.',
        pairs: [
          { q: 'Wie fährst du zur Arbeit?', a: 'Meistens mit der U-Bahn.' },
          { q: 'Was ist schneller: Bus oder U-Bahn?', a: 'Die U-Bahn ist schneller.' },
          { q: 'Hast du ein Auto?', a: 'Nein, ich fahre lieber Fahrrad.' },
          { q: 'Wie lange dauert die Fahrt?', a: 'Ungefähr 30 Minuten.' },
        ]},
      mittel: { type: 'gap', instruction: 'Am Bahnhof.',
        sentences: [
          { text: 'Entschuldigung, wann ___ der nächste Zug nach München?', options: ['fährt', 'geht', 'kommt'], answer: 0 },
          { text: 'Einmal München, hin und ___. Zweite Klasse bitte.', options: ['weg', 'zurück', 'her'], answer: 1 },
          { text: 'Von welchem ___ fährt der Zug?', options: ['Gleis', 'Bahnhof', 'Platz'], answer: 0 },
        ]},
      schwer: { type: 'gap', instruction: 'Diskussion: Auto oder öffentliche Verkehrsmittel?',
        sentences: [
          { text: 'Ich finde, man ___ mehr öffentliche Verkehrsmittel benutzen.', options: ['sollte', 'musste', 'wollte'], answer: 0 },
          { text: 'Das wäre besser für die ___.', options: ['Umwelt', 'Arbeit', 'Schule'], answer: 0 },
          { text: 'Auf dem Land ist man ohne Auto aber oft ___.', options: ['aufgeschmissen', 'glücklich', 'schnell'], answer: 0 },
        ]},
    },
  },

  // ──────── LEKTION 7-12 (compact format) ────────
  L7: { title: 'Lektion 7: Wir könnten kurz vor dem See zelten.',
    worter: { leicht: { type: 'sort', instruction: 'Natur: Tiere oder Landschaft?', categories: ['Tiere / Animals', 'Landschaft / Landscape'], items: [
      { word: 'der Vogel', cat: 0 }, { word: 'der Fisch', cat: 0 }, { word: 'das Reh', cat: 0 }, { word: 'der Hase', cat: 0 },
      { word: 'der See', cat: 1 }, { word: 'der Berg', cat: 1 }, { word: 'der Wald', cat: 1 }, { word: 'die Wiese', cat: 1 }, { word: 'der Fluss', cat: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Camping und Natur.', sentences: [
      { text: 'Wir könnten am ___ zelten.', options: ['See', 'Bahnhof', 'Büro'], answer: 0 },
      { text: 'Vergiss nicht den ___! Es wird kalt nachts.', options: ['Schlafsack', 'Laptop', 'Drucker'], answer: 0 },
      { text: 'Im ___ gibt es viele Wanderwege.', options: ['Wald', 'Büro', 'Kino'], answer: 0 },
      { text: 'Das Wetter wird ___. Wir brauchen Regenjacken.', options: ['schlecht', 'heiß', 'sonnig'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Vorschläge machen.', sentences: [
      { text: 'Wir ___ eine Wanderung machen.', options: ['könnten', 'mussten', 'sollten'], answer: 0 },
      { text: 'Wie ___ es, wenn wir morgen früh starten?', options: ['wäre', 'ist', 'hat'], answer: 0 },
      { text: 'Hättest du ___, am Wochenende zu wandern?', options: ['Lust', 'Hunger', 'Angst'], answer: 0 },
      { text: 'Wir sollten rechtzeitig einen ___ buchen.', options: ['Campingplatz', 'Arzt', 'Friseur'], answer: 0 },
      { text: 'Im Zelt wird es nachts sehr ___. Zieh dich warm an!', options: ['kalt', 'heiß', 'laut'], answer: 0 },
    ]}},
    strukturen: { leicht: { type: 'gap', instruction: 'Konjunktiv II: könnte, sollte, müsste.', sentences: [
      { text: 'Wir ___ am See zelten. (could)', options: ['könnten', 'können', 'konnten'], answer: 0 },
      { text: 'Du ___ warme Kleidung mitnehmen. (should)', options: ['solltest', 'sollst', 'musst'], answer: 0 },
      { text: 'Man ___ den Müll immer mitnehmen.', options: ['müsste', 'muss', 'kann'], answer: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Nebensätze mit „wenn".', sentences: [
      { text: '___ es regnet, bleiben wir im Zelt.', options: ['Wenn', 'Weil', 'Dass'], answer: 0 },
      { text: 'Wir machen ein Lagerfeuer, ___ es nicht regnet.', options: ['wenn', 'weil', 'dass'], answer: 0 },
      { text: '___ du Lust hast, können wir morgen wandern.', options: ['Wenn', 'Weil', 'Dass'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Vorschläge ordnen.', sentences: [
      { words: ['könnten', 'Wir', 'am', 'See', 'zelten'], answer: 'Wir könnten am See zelten' },
      { words: ['solltest', 'Du', 'eine', 'Jacke', 'mitnehmen'], answer: 'Du solltest eine Jacke mitnehmen' },
    ]}},
    kommunikation: { leicht: { type: 'match', instruction: 'Vorschläge für den Ausflug.', pairs: [
      { q: 'Was könnten wir am Wochenende machen?', a: 'Wir könnten wandern gehen.' },
      { q: 'Sollen wir zelten?', a: 'Gute Idee! Am See wäre toll.' },
      { q: 'Was müssen wir mitnehmen?', a: 'Schlafsack, Zelt und warme Kleidung.' },
    ]}, mittel: { type: 'gap', instruction: 'Vorschläge machen und reagieren.', sentences: [
      { text: 'A: ___ wäre es mit einer Wanderung?', options: ['Wie', 'Was', 'Wann'], answer: 0 },
      { text: 'B: Gute ___! Wann sollen wir starten?', options: ['Idee', 'Nacht', 'Reise'], answer: 0 },
      { text: 'A: Am besten ___ am Morgen.', options: ['früh', 'spät', 'nie'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Wetter besprechen.', sentences: [
      { text: 'Die ___ sagt: Morgen wird es sonnig.', options: ['Wettervorhersage', 'Zeitung', 'Nachbarin'], answer: 0 },
      { text: 'Bei schlechtem Wetter ___ wir zu Hause bleiben.', options: ['könnten', 'mussten', 'durften'], answer: 0 },
    ]}},
  },

  L8: { title: 'Lektion 8: Ich freue mich so.',
    worter: { leicht: { type: 'sort', instruction: 'Ereignisse: Freudig oder Traurig?', categories: ['Freudig', 'Traurig'], items: [
      { word: 'die Hochzeit', cat: 0 }, { word: 'die Geburt', cat: 0 }, { word: 'die Beförderung', cat: 0 },
      { word: 'der Geburtstag', cat: 0 }, { word: 'der Abschied', cat: 1 },
      { word: 'die Kündigung', cat: 1 }, { word: 'der Verlust', cat: 1 }, { word: 'die Trennung', cat: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Freude und Glückwünsche.', sentences: [
      { text: 'Herzlichen ___ zum Geburtstag!', options: ['Glückwunsch', 'Dank', 'Gruß'], answer: 0 },
      { text: 'Ich ___ mich so für dich!', options: ['freue', 'ärgere', 'sorge'], answer: 0 },
      { text: 'Wir ___ euch zur Hochzeit!', options: ['gratulieren', 'danken', 'bitten'], answer: 0 },
      { text: 'Das ist ja ___! (wonderful)', options: ['wunderbar', 'schrecklich', 'langweilig'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Verben mit Präpositionen.', sentences: [
      { text: 'Ich freue mich ___ die Party.', options: ['auf', 'über', 'für'], answer: 0 },
      { text: 'Sie freut sich ___ das Geschenk.', options: ['auf', 'über', 'für'], answer: 1 },
      { text: 'Wir gratulieren dir ___ Geburtstag!', options: ['zum', 'am', 'im'], answer: 0 },
      { text: 'Er interessiert sich ___ Fußball.', options: ['für', 'auf', 'über'], answer: 0 },
      { text: 'Ich denke ___ meine Familie.', options: ['an', 'auf', 'für'], answer: 0 },
    ]}},
    strukturen: { leicht: { type: 'gap', instruction: 'Verben mit Präpositionen.', sentences: [
      { text: 'Ich warte ___ den Bus. (auf)', options: ['auf', 'für', 'an'], answer: 0 },
      { text: 'Er denkt ___ seine Familie. (an)', options: ['für', 'an', 'über'], answer: 1 },
      { text: 'Wir sprechen ___ das Problem. (über)', options: ['über', 'auf', 'für'], answer: 0 },
      { text: 'Sie interessiert sich ___ Musik. (für)', options: ['für', 'an', 'über'], answer: 0 },
    ]}, mittel: { type: 'gap', instruction: 'sich freuen auf vs. sich freuen über.', sentences: [
      { text: 'Ich freue mich ___ den Urlaub. (future event)', options: ['auf', 'über', 'für'], answer: 0 },
      { text: 'Ich freue mich ___ das Geschenk. (received)', options: ['auf', 'über', 'für'], answer: 1 },
      { text: 'Wir freuen uns ___ das Wiedersehen. (future)', options: ['auf', 'über', 'für'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Sätze mit Verben + Präposition ordnen.', sentences: [
      { words: ['freue', 'Ich', 'mich', 'auf', 'die', 'Reise'], answer: 'Ich freue mich auf die Reise' },
      { words: ['sich', 'Er', 'ärgert', 'über', 'den', 'Stau'], answer: 'Er ärgert sich über den Stau' },
    ]}},
    kommunikation: { leicht: { type: 'match', instruction: 'Glückwünsche und Reaktionen.', pairs: [
      { q: 'Ich habe die Prüfung bestanden!', a: 'Herzlichen Glückwunsch! Toll!' },
      { q: 'Wir bekommen ein Baby!', a: 'Das ist ja wunderbar! Ich freue mich für euch!' },
      { q: 'Ich habe eine neue Stelle!', a: 'Super! Das freut mich!' },
    ]}, mittel: { type: 'gap', instruction: 'Gratulieren.', sentences: [
      { text: 'Alles ___ zum Geburtstag!', options: ['Gute', 'Beste', 'Schöne'], answer: 0 },
      { text: 'Ich ___ dir ganz herzlich!', options: ['gratuliere', 'danke', 'bitte'], answer: 0 },
      { text: 'Viel ___ bei der neuen Arbeit!', options: ['Erfolg', 'Spaß', 'Glück'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Mitfühlen und Trösten.', sentences: [
      { text: 'Das tut mir sehr ___. (sorry)', options: ['leid', 'gut', 'weh'], answer: 0 },
      { text: 'Ich bin ___ für dich da.', options: ['immer', 'nie', 'selten'], answer: 0 },
    ]}},
  },

  L9: { title: 'Lektion 9: Ich brauche bitte einen Termin.',
    worter: { leicht: { type: 'sort', instruction: 'Termin: Beim Arzt oder bei der Behörde?', categories: ['Beim Arzt', 'Bei der Behörde'], items: [
      { word: 'die Sprechstunde', cat: 0 }, { word: 'das Rezept', cat: 0 }, { word: 'die Überweisung', cat: 0 },
      { word: 'der Impfpass', cat: 0 }, { word: 'die Versicherungskarte', cat: 0 },
      { word: 'der Personalausweis', cat: 1 }, { word: 'das Formular', cat: 1 },
      { word: 'die Anmeldung', cat: 1 }, { word: 'das Einwohnermeldeamt', cat: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Termine machen.', sentences: [
      { text: 'Ich ___ gern einen Termin vereinbaren.', options: ['möchte', 'muss', 'kann'], answer: 0 },
      { text: 'Wann ___ Sie kommen?', options: ['könnten', 'mussten', 'wollten'], answer: 0 },
      { text: 'Geht es am ___ um 10 Uhr?', options: ['Dienstag', 'morgen', 'bald'], answer: 0 },
      { text: 'Bitte bringen Sie Ihre ___ mit.', options: ['Versicherungskarte', 'Brille', 'Jacke'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Termin absagen oder verschieben.', sentences: [
      { text: 'Leider muss ich den Termin ___.', options: ['absagen', 'bestätigen', 'buchen'], answer: 0 },
      { text: 'Können wir den Termin auf nächste Woche ___?', options: ['verschieben', 'absagen', 'vergessen'], answer: 0 },
      { text: 'Ich ___ mich für die Unannehmlichkeiten.', options: ['entschuldige', 'freue', 'ärgere'], answer: 0 },
      { text: 'Der nächste freie Termin ist am ___.', options: ['Montag', 'Frühstück', 'Fenster'], answer: 0 },
      { text: 'Bitte bestätigen Sie den Termin per ___.', options: ['E-Mail', 'Fahrrad', 'Taxi'], answer: 0 },
    ]}},
    strukturen: { leicht: { type: 'gap', instruction: 'Temporale Präpositionen: am, um, im, von...bis.', sentences: [
      { text: 'Der Termin ist ___ Montag.', options: ['am', 'um', 'im'], answer: 0 },
      { text: 'Wir treffen uns ___ 15 Uhr.', options: ['am', 'um', 'im'], answer: 1 },
      { text: 'Die Praxis ist ___ Sommer geschlossen.', options: ['am', 'um', 'im'], answer: 2 },
      { text: 'Die Sprechstunde ist ___ 8 ___ 12 Uhr.', options: ['von...bis', 'am...um', 'im...am'], answer: 0 },
    ]}, mittel: { type: 'gap', instruction: 'Indirekte Fragen mit „ob".', sentences: [
      { text: 'Ich möchte wissen, ___ Sie morgen Zeit haben.', options: ['ob', 'dass', 'weil'], answer: 0 },
      { text: 'Können Sie mir sagen, ___ der Arzt da ist?', options: ['ob', 'dass', 'weil'], answer: 0 },
      { text: 'Ich frage mich, ___ der Termin noch frei ist.', options: ['ob', 'dass', 'weil'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Terminsätze ordnen.', sentences: [
      { words: ['einen', 'Ich', 'brauche', 'Termin', 'beim', 'Arzt'], answer: 'Ich brauche einen Termin beim Arzt' },
      { words: ['ob', 'Wissen', 'Sie', 'Montag', 'geht', '?'], answer: 'Wissen Sie ob Montag geht?' },
    ]}},
    kommunikation: { leicht: { type: 'match', instruction: 'Am Telefon: Termin vereinbaren.', pairs: [
      { q: 'Praxis Dr. Müller, guten Tag.', a: 'Guten Tag, ich bräuchte einen Termin.' },
      { q: 'Wann passt es Ihnen?', a: 'Am besten nächste Woche.' },
      { q: 'Geht es am Mittwoch um 10?', a: 'Ja, das passt gut. Danke.' },
    ]}, mittel: { type: 'gap', instruction: 'Termin am Telefon.', sentences: [
      { text: 'A: Guten Tag, ich ___ gern einen Termin.', options: ['hätte', 'habe', 'hatte'], answer: 0 },
      { text: 'B: ___ es denn dringend?', options: ['Ist', 'Hat', 'Wird'], answer: 0 },
      { text: 'A: Ja, ich habe starke ___.', options: ['Schmerzen', 'Freude', 'Hunger'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Behördengang.', sentences: [
      { text: 'Bitte füllen Sie dieses ___ aus.', options: ['Formular', 'Rezept', 'Buch'], answer: 0 },
      { text: 'Haben Sie Ihren ___ dabei?', options: ['Personalausweis', 'Schlüssel', 'Laptop'], answer: 0 },
    ]}},
  },

  L10: { title: 'Lektion 10: So ein Zufall!',
    worter: { leicht: { type: 'sort', instruction: 'Erzählen: Zeitadverbien sortieren.', categories: ['Vergangenheit', 'Gegenwart / Zukunft'], items: [
      { word: 'gestern', cat: 0 }, { word: 'letzte Woche', cat: 0 }, { word: 'vor einem Jahr', cat: 0 },
      { word: 'früher', cat: 0 }, { word: 'als Kind', cat: 0 },
      { word: 'heute', cat: 1 }, { word: 'morgen', cat: 1 }, { word: 'nächste Woche', cat: 1 },
      { word: 'bald', cat: 1 }, { word: 'jetzt', cat: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Geschichten erzählen.', sentences: [
      { text: 'Stell dir vor, ___ habe ich meinen alten Freund getroffen!', options: ['gestern', 'morgen', 'bald'], answer: 0 },
      { text: 'Das war ein ___! (coincidence)', options: ['Zufall', 'Problem', 'Fehler'], answer: 0 },
      { text: 'Wir haben uns seit 10 Jahren nicht ___!', options: ['gesehen', 'getroffen', 'geschrieben'], answer: 0 },
      { text: 'Er hat sich sehr ___. (changed)', options: ['verändert', 'gefreut', 'geärgert'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Nebensätze mit „als" (Vergangenheit).', sentences: [
      { text: '___ ich ein Kind war, habe ich in Berlin gewohnt.', options: ['Als', 'Wenn', 'Weil'], answer: 0 },
      { text: '___ wir uns trafen, war er überrascht.', options: ['Als', 'Wenn', 'Dass'], answer: 0 },
      { text: '___ ich 18 war, bin ich nach Deutschland gekommen.', options: ['Als', 'Wenn', 'Weil'], answer: 0 },
    ]}},
    strukturen: { leicht: { type: 'gap', instruction: '„als" (einmal in der Vergangenheit) vs. „wenn" (immer/Zukunft).', sentences: [
      { text: '___ ich klein war, spielte ich im Garten. (once, past)', options: ['Als', 'Wenn', 'Weil'], answer: 0 },
      { text: '___ es regnet, bleibe ich zu Hause. (every time)', options: ['Als', 'Wenn', 'Weil'], answer: 1 },
      { text: '___ du kommst, ruf mich an. (future)', options: ['Als', 'Wenn', 'Weil'], answer: 1 },
      { text: '___ ich 10 war, zogen wir um. (once, past)', options: ['Als', 'Wenn', 'Weil'], answer: 0 },
    ]}, mittel: { type: 'gap', instruction: 'Perfekt: Unregelmäßige Verben.', sentences: [
      { text: 'Ich habe ihn zufällig ___. (treffen)', options: ['getroffen', 'getrefft', 'treffen'], answer: 0 },
      { text: 'Wir sind nach Berlin ___. (fahren)', options: ['gefahren', 'gefahrt', 'fahren'], answer: 0 },
      { text: 'Er hat mir seine Geschichte ___. (erzählen)', options: ['erzählt', 'erzählen', 'erzielt'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Sätze mit „als" ordnen.', sentences: [
      { words: ['war', 'Als', 'ich', 'Kind', 'lebte', 'ich', 'in', 'Kairo'], answer: 'Als ich Kind war lebte ich in Kairo' },
      { words: ['trafen', 'Als', 'wir', 'uns', 'war', 'es', 'Zufall'], answer: 'Als wir uns trafen war es Zufall' },
    ]}},
    kommunikation: { leicht: { type: 'match', instruction: 'Überraschung ausdrücken.', pairs: [
      { q: 'Rate mal, wen ich getroffen habe!', a: 'Wen denn? Erzähl!' },
      { q: 'So ein Zufall!', a: 'Ja, unglaublich!' },
      { q: 'Stell dir vor, was passiert ist!', a: 'Was denn? Jetzt bin ich neugierig!' },
    ]}, mittel: { type: 'gap', instruction: 'Eine Geschichte erzählen.', sentences: [
      { text: 'A: Stell dir ___! Ich habe Maria getroffen!', options: ['vor', 'ein', 'auf'], answer: 0 },
      { text: 'B: Echt? Das ist ja ein ___!', options: ['Zufall', 'Problem', 'Witz'], answer: 0 },
      { text: 'A: Ja, wir haben uns seit der ___ nicht gesehen.', options: ['Schulzeit', 'Arbeit', 'Reise'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Erinnerungen teilen.', sentences: [
      { text: 'Weißt du noch, ___ wir zusammen in der Schule waren?', options: ['als', 'wenn', 'weil'], answer: 0 },
      { text: 'Das waren ___! (good times)', options: ['schöne Zeiten', 'schlimme Tage', 'lange Nächte'], answer: 0 },
    ]}},
  },

  L11: { title: 'Lektion 11: Mein Zimmer im Studentenwohnheim.',
    worter: { leicht: { type: 'sort', instruction: 'Wohnen: Positiv oder Negativ?', categories: ['Positiv', 'Negativ'], items: [
      { word: 'hell (bright)', cat: 0 }, { word: 'gemütlich (cozy)', cat: 0 }, { word: 'günstig (affordable)', cat: 0 },
      { word: 'ruhig (quiet)', cat: 0 }, { word: 'zentral (central)', cat: 0 },
      { word: 'laut (loud)', cat: 1 }, { word: 'dunkel (dark)', cat: 1 }, { word: 'teuer (expensive)', cat: 1 },
      { word: 'eng (cramped)', cat: 1 }, { word: 'schmutzig (dirty)', cat: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Wohnungssuche.', sentences: [
      { text: 'Ich suche ein ___ in einer WG.', options: ['Zimmer', 'Haus', 'Büro'], answer: 0 },
      { text: 'Die ___ beträgt 450 Euro pro Monat.', options: ['Miete', 'Rechnung', 'Steuer'], answer: 0 },
      { text: 'Die Wohnung hat zwei Zimmer, Küche und ___.', options: ['Bad', 'Garten', 'Garage'], answer: 0 },
      { text: 'Die ___ sind 150 Euro zusätzlich.', options: ['Nebenkosten', 'Möbel', 'Gardinen'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'WG-Regeln.', sentences: [
      { text: 'Jeder muss die ___ sauber halten.', options: ['Küche', 'Stadt', 'Straße'], answer: 0 },
      { text: 'Am Wochenende darf man nicht zu ___ Musik hören.', options: ['leise', 'laut', 'schön'], answer: 1 },
      { text: 'Wir ___ uns die Kosten für Internet.', options: ['teilen', 'verdoppeln', 'vergessen'], answer: 0 },
    ]}},
    strukturen: { leicht: { type: 'gap', instruction: 'Adjektivdeklination: ein/eine/ein + Adjektiv.', sentences: [
      { text: 'Das ist ein ___ Zimmer. (groß)', options: ['großes', 'große', 'großer'], answer: 0 },
      { text: 'Ich suche eine ___ Wohnung. (günstig)', options: ['günstige', 'günstiges', 'günstiger'], answer: 0 },
      { text: 'Er hat einen ___ Balkon. (klein)', options: ['kleinen', 'kleine', 'kleines'], answer: 0 },
      { text: 'Das ist ein ___ Bad. (modern)', options: ['modernes', 'moderne', 'moderner'], answer: 0 },
    ]}, mittel: { type: 'gap', instruction: 'Adjektivdeklination nach bestimmtem Artikel.', sentences: [
      { text: 'Die ___ Wohnung kostet 800 Euro. (groß)', options: ['große', 'großes', 'großer'], answer: 0 },
      { text: 'Der ___ Balkon gefällt mir. (klein)', options: ['kleine', 'kleines', 'kleinen'], answer: 0 },
      { text: 'Das ___ Zimmer ist meins. (hell)', options: ['helle', 'heller', 'helles'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Wohnungsbeschreibung ordnen.', sentences: [
      { words: ['ist', 'Das', 'ein', 'schönes', 'helles', 'Zimmer'], answer: 'Das ist ein schönes helles Zimmer' },
      { words: ['suche', 'Ich', 'eine', 'günstige', 'Wohnung'], answer: 'Ich suche eine günstige Wohnung' },
    ]}},
    kommunikation: { leicht: { type: 'match', instruction: 'WG-Casting.', pairs: [
      { q: 'Erzähl mal etwas über dich.', a: 'Ich studiere Medizin und bin 24 Jahre alt.' },
      { q: 'Was machst du in deiner Freizeit?', a: 'Ich koche gern und höre Musik.' },
      { q: 'Wie findest du das Zimmer?', a: 'Es ist schön und hell. Mir gefällt es!' },
    ]}, mittel: { type: 'gap', instruction: 'Wohnungsanzeige verstehen.', sentences: [
      { text: '2-Zi.-Whg. bedeutet: Zwei-___-Wohnung.', options: ['Zimmer', 'Zone', 'Zeit'], answer: 0 },
      { text: 'KM = Kalt___, ohne Nebenkosten.', options: ['miete', 'milch', 'meer'], answer: 0 },
      { text: 'NK = Neben___.', options: ['kosten', 'kinder', 'küche'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Über die Wohnung sprechen.', sentences: [
      { text: 'Die Lage ist ___. Alles ist gut erreichbar.', options: ['zentral', 'laut', 'dunkel'], answer: 0 },
      { text: 'Die Wohnung ist ___ möbliert.', options: ['voll', 'halb', 'nicht'], answer: 0 },
    ]}},
  },

  L12: { title: 'Lektion 12: Es wird noch besser.',
    worter: { leicht: { type: 'sort', instruction: 'Zukunft: Hoffnungen oder Sorgen?', categories: ['Hoffnungen / Hopes', 'Sorgen / Worries'], items: [
      { word: 'ein guter Job', cat: 0 }, { word: 'mehr Freizeit', cat: 0 }, { word: 'eine Familie gründen', cat: 0 },
      { word: 'Deutsch perfekt sprechen', cat: 0 },
      { word: 'Geld verlieren', cat: 1 }, { word: 'keinen Job finden', cat: 1 },
      { word: 'allein sein', cat: 1 }, { word: 'krank werden', cat: 1 },
    ]}, mittel: { type: 'gap', instruction: 'Zukunft mit „werden".', sentences: [
      { text: 'Ich ___ nächstes Jahr die B1-Prüfung machen.', options: ['werde', 'wurde', 'würde'], answer: 0 },
      { text: 'Er ___ in Deutschland Medizin studieren.', options: ['wird', 'wurde', 'würde'], answer: 0 },
      { text: 'Wir ___ bald eine neue Wohnung finden.', options: ['werden', 'wurden', 'würden'], answer: 0 },
      { text: 'Es ___ bestimmt besser!', options: ['wird', 'wurde', 'war'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Zukunftspläne.', sentences: [
      { text: 'In 5 Jahren ___ ich als Krankenschwester in Deutschland arbeiten.', options: ['werde', 'wurde', 'würde'], answer: 0 },
      { text: 'Mein ___ ist es, die Anerkennung zu bekommen.', options: ['Ziel', 'Problem', 'Fehler'], answer: 0 },
      { text: 'Ich bin ___, dass alles gut wird.', options: ['sicher', 'traurig', 'müde'], answer: 0 },
      { text: 'Ich werde mein ___ geben, die Prüfung zu bestehen.', options: ['Bestes', 'Letztes', 'Erstes'], answer: 0 },
      { text: 'Meine ___ ist es, fließend Deutsch zu sprechen.', options: ['Hoffnung', 'Angst', 'Sorge'], answer: 0 },
    ]}},
    strukturen: { leicht: { type: 'gap', instruction: 'Futur I: werden + Infinitiv.', sentences: [
      { text: 'Ich ___ morgen anfangen. (werden)', options: ['werde', 'wurde', 'will'], answer: 0 },
      { text: 'Du ___ es schaffen! (werden)', options: ['wirst', 'wurdest', 'willst'], answer: 0 },
      { text: 'Er ___ nach Berlin ziehen. (werden)', options: ['wird', 'wurde', 'will'], answer: 0 },
      { text: 'Wir ___ zusammen lernen. (werden)', options: ['werden', 'wurden', 'wollen'], answer: 0 },
    ]}, mittel: { type: 'gap', instruction: 'Nebensätze: Zukunftspläne begründen.', sentences: [
      { text: 'Ich lerne Deutsch, ___ ich in Deutschland arbeiten will.', options: ['weil', 'dass', 'ob'], answer: 0 },
      { text: 'Ich hoffe, ___ ich die Prüfung bestehe.', options: ['dass', 'weil', 'ob'], answer: 0 },
      { text: 'Ich weiß nicht, ___ ich hierbleiben werde.', options: ['ob', 'dass', 'weil'], answer: 0 },
    ]}, schwer: { type: 'order', instruction: 'Zukunftssätze ordnen.', sentences: [
      { words: ['werde', 'Ich', 'Deutsch', 'perfekt', 'sprechen'], answer: 'Ich werde Deutsch perfekt sprechen' },
      { words: ['wird', 'Es', 'bestimmt', 'besser'], answer: 'Es wird bestimmt besser' },
      { words: ['werden', 'Wir', 'es', 'schaffen'], answer: 'Wir werden es schaffen' },
    ]}},
    kommunikation: { leicht: { type: 'match', instruction: 'Über die Zukunft sprechen.', pairs: [
      { q: 'Was wirst du nach dem Kurs machen?', a: 'Ich werde die B1-Prüfung machen.' },
      { q: 'Wo siehst du dich in 5 Jahren?', a: 'Ich hoffe, in Deutschland als Pfleger zu arbeiten.' },
      { q: 'Glaubst du, es wird besser?', a: 'Ja, bestimmt! Es wird noch besser.' },
    ]}, mittel: { type: 'gap', instruction: 'Pläne und Wünsche.', sentences: [
      { text: 'Mein Traum ist es, ___ zu werden.', options: ['Arzt', 'reich', 'faul'], answer: 0 },
      { text: 'Ich werde ___ mein Bestes geben.', options: ['immer', 'nie', 'selten'], answer: 0 },
      { text: 'Wir werden ___ nicht aufgeben!', options: ['sicher', 'leider', 'vielleicht'], answer: 0 },
    ]}, schwer: { type: 'gap', instruction: 'Vorsätze fürs neue Jahr.', sentences: [
      { text: 'Dieses Jahr werde ich mehr ___ treiben.', options: ['Sport', 'Spaß', 'Schlaf'], answer: 0 },
      { text: 'Ich ___ mir vor, gesünder zu essen.', options: ['nehme', 'gebe', 'mache'], answer: 0 },
    ]}},
  },
};

export default EXERCISES_A21;
